import FacebookSquareIcon from "../../../assets/icons/Facebook-Square";
import TwitterSquareIcon from "../../../assets/icons/Twitter-Square";
import LinkedinSquareIcon from "../../../assets/icons/Linkedin-Square";
import InstagramSquareIcon from "../../../assets/icons/Instagram-Square";

export const footerTextContent = {
  copyRightText:
    "Copyright 2025 | All Rights Reserved | Privacy Policy | Cookie Policy",
  content: [
    {
      titleText: "Solutions",
      linkContent: [
        { linkText: "iGaming Platform" },
        { linkText: "Sports Betting Software" },
        { linkText: "Online/Live Casino Software" },
        { linkText: "Casino Game Development" },
        { linkText: "Slot Game Development" },
        { linkText: "Sweepstakes Casino Software" },
        { linkText: "Provably Fair Casino Games" },
        { linkText: "Retail Solutions" },
        { linkText: "Online & Retail Lottery Software" },
        { linkText: "Gaming Licenses" },
      ],
    },
    {
      titleText: "Services",
      linkContent: [
        { linkText: "iGaming Staffing" },
        { linkText: "Bespoke Development" },
        { linkText: "3rd Party API Integration" },
        { linkText: "Technical Support" },
        { linkText: "Design Services" },
        { linkText: "Testing Services" },
      ],
      imageContent: [
        {
          imageSrc: "/assets/stock-img/service_logo_img.webp",
          imageClass: "service-img",
        },
      ],
    },
    {
      titleText: "Quick Links",
      linkContent: [
        { linkText: "About Us" },
        { linkText: "Blog" },
        { linkText: "Careers" },
        // { linkText: "Contact Us", link: '/contact-us' },
        { linkText: "More", link: '/slot-games-list' },
        { linkText: "Home", link: '/' },
        { linkText: "Why Us", link: '/why-us' },
        { linkText: "Services", link: '/services' },
      ],
      iconContent: [
        { socialIcon: <FacebookSquareIcon /> },
        { socialIcon: <TwitterSquareIcon /> },
        { socialIcon: <LinkedinSquareIcon /> },
        { socialIcon: <InstagramSquareIcon /> },
      ],
      imageContent: [
        {
          imageSrc: "/assets/stock-img/forbes_logo_img.webp",
          imageClass: "forbes-img",
        },
        {
          imageSrc: "/assets/stock-img/rising_star_logo_img.webp",
          imageClass: "rising-img",
        },
        {
          imageSrc: "/assets/stock-img/premium_usability_logo_img.webp",
          imageClass: "premium-img",
        },
      ],
    },
    {
      titleText: "Address",
      addressContent: [
        // {
        //   addressTitle: "USA :",
        //   addressText:
        //     "3411 Silverside Road, Tatnall Building Ste 104 Wilmington, De 19810",
        // },
        {
          addressTitle: "Indore :",
          addressText:
            "6th Floor, Crystal IT Park, Indore 452014 (M.P.), India",
        },
        // {
        //   addressTitle: "Pune :",
        //   addressText:
        //     "207, 2nd Floor , Turning Point 2, Opp. to Rosary School, Viman Nagar, Pune",
        // },
        {
          addressTitle: "Malta :",
          addressText:
            "Dragonara Business Centre, 5th Floor, Dragonara Road, City/locality St. Julians Stj 3141",
        },
        // {
        //   addressTitle: "Latvia :",
        //   addressText: "Krišjāņa Valdemāra iela 149 - 5, Rīga, LV-1013",
        // },
      ],
    },
  ],
};
